// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__3K5C-","active":"Pagination_active__S-Btt"};